import urlFilter from "../filters/url.filter";
import { CatalogsTypes } from "./enums/catalogsTypes";
import { OperationRequestData } from "./operationRequestData";
import { Dictionary } from "vue-router/types/router";

/**  Данные по каталогу. */
export class CatalogData {
  /**Идентификатор в ДБО. */
  public Id: number = 0;
  /**Тип каталога. */
  public CatalogType: CatalogsTypes = CatalogsTypes.Folder;
  /**Признак активности элемента. */
  public IsActive: boolean = false;
  /** Признак продукта */
  public IsProduct: boolean = false;
  /** Признак заявки */
  public IsClientRequest: boolean = false;
  /**Заголовок. */
  public Caption: string = "";
  /**Описание. */
  public Description: string = "";
  /**ИД родителя. */
  public ParentId: number = 0;
  /** Ссылка на картинку. */
  public Picture: string = "";
  /**Ссылка на картинку. */
  public BigImage: string = "";
  /**ProgId операции. */
  public ProgId: string = "";
  /**Config операции. */
  public Config: string = "";
  /**Категория. */
  public Category: string = "";
  /**Признак необходимости подтверждения. */
  public IsConfirm: boolean = false;
  /**Признак прямого доступа к элементу каталога. */
  public IsDirect: boolean = false;
  /**Признак прямого доступа к элементу каталога. */
  public IsFolder: boolean = false;
  /**Признак информационного доступа. */
  public IsInformationAccess: boolean = false;
  /**Признак ограниченного доступа. */
  public IsLimitedAccess: boolean = false;
  /** Признак отображения информации перед проведением. */
  public IsOperationInfoExtItem: boolean = false;
  /**Дочерние элементы. */
  public Childrens: Array<CatalogData> = [];

  public ProhibitReplay: boolean = false;

  /**Данные операции */
  public AdditionalInitData: Dictionary<string> = {};

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.Id = src.Id ?? 0;
      this.CatalogType = (src.Type ?? 0) as CatalogsTypes;
      this.IsActive = src.Active ?? false;
      this.IsProduct = src.IsProduct ?? false;
      this.IsClientRequest = src.IsClientRequest ?? false;
      this.IsFolder = this.CatalogType == CatalogsTypes.Folder;
      this.Caption = src.Caption ?? "";
      this.Description = src.Description ?? "";
      this.ParentId = src.ParentId ?? 0;
      this.Category = src.Category ?? "";
      this.Picture = urlFilter(src.Picture ?? "");
      this.BigImage = src.BigImage ?? "";

      if (this.CatalogType == CatalogsTypes.Operation) {
        this.ProgId = src.ProgId ?? "";
        this.Config = src.Config ?? "";
        this.IsConfirm = src.ConfirmItem ?? false;
        this.IsDirect = src.DirectItem ?? false;
        this.IsInformationAccess = src.InformationAccess ?? false;
        this.IsLimitedAccess = src.LimitedAccess ?? false;
        this.IsOperationInfoExtItem = src.OperationInfoExtItem ?? false;
        this.ProhibitReplay = src.ProhibitReplay ?? false;
        return;
      }

      if (src.Childrens) {
        src.Childrens.forEach((children: any) => {
          this.Childrens.push(new CatalogData(children));
        });
      }
    }
  }

  fillFromRequest(ord: OperationRequestData): void {
    const id = parseInt(ord.respondentCode)
    this.Id = isNaN(id) ? 0 : id;
      this.CatalogType = CatalogsTypes.ExtOperation;
      this.Caption = ord.caption;
      this.Description = ord.getPropertyValue("inn");
      this.Picture = ord.picture ? urlFilter(ord.picture) : "";
      ord.keys.forEach((k: string) => {
          this.AdditionalInitData[k]=ord.getPropertyValue(k);
      });
  }
}
